import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Q() {
    const { useLang, Link, useRouter, useState, useEffect } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('vanliferoadtrips');
    const LOCAL_SITES = ['de', 'it', 'es', 'uk', 'au', 'fr'];
    const [gap, setGap] = useState(24);
    const items: any = [
        {
            img: '/responsive/picture/vanlife-roadtrips/16_1',
            desc: t('secQ_card1_text'),
            link: t('secQ_card1_link'),
        },
        {
            img: '/responsive/picture/vanlife-roadtrips/16_2',
            desc: t('secQ_card2_text'),
            link: t('secQ_card2_link'),
        },
        {
            img: '/responsive/picture/vanlife-roadtrips/16_3',
            desc: t('secQ_card3_text'),
            link: t('secQ_card3_link'),
        },
        {
            img: `/responsive/picture/vanlife-roadtrips/16_${locale === 'ca' ? '5' : '4'}`,
            desc: t('secQ_card4_text'),
            link: t('secQ_card4_link'),
        },
        {
            img: '/responsive/picture/vanlife-roadtrips/16_5',
            desc: t('secQ_card5_text'),
            link: t('secQ_card5_link'),
        },
        {
            img: '/responsive/picture/vanlife-roadtrips/16_6',
            desc: t('secQ_card6_text'),
            link: t('secQ_card6_link'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    return (
        <div id="vanlife-roadtrips-Q" className={`vanlife-roadtrips-Q ${css['vanlife-roadtrips-Q']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secQ_title')}</p>
                </div>
                <Swiper
                    className={`swiper-box`}
                    effect="fade"
                    modules={[Scrollbar, Navigation]}
                    navigation={true}
                    spaceBetween={gap}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {(['ca', 'de', 'za', 'it', 'es'].includes(locale) ? items.slice(0, 4) : locale === 'fr' ? items.slice(0, 3) : items)?.map(
                        (card: any, k: number) => (
                            <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                                <EFPicture className="card-img" src={`${card?.img}${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`} alt={card.desc} />
                                <p className="card-desc">{card?.desc}</p>
                                <Link className="card-link" href={card?.link}>
                                    <span className="link-text">{t('common_card_more')}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <path
                                            d="M6.50006 12.3291L10.5001 8.3291L6.50006 4.3291"
                                            stroke="#2673FF"
                                            strokeWidth="1.33333"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Link>
                            </SwiperSlide>
                        ),
                    )}
                </Swiper>
            </div>
        </div>
    );
}
